import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  constructor( private readonly translate: TranslateService) { }

  options: AnimationOptions = {
    loop:true,
    path: './assets/images/404_template.json',
  };

  animationCreated(animationItem: AnimationItem): void {
    animationItem.setSpeed(0.8);
  }

  public ngOnInit() {
  }

}
